<div class="container" *ngIf="copyLoaded">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2">
      <h3 [innerHTML]="appCopy.panelHeader['pageNotFoundTitle'+selectedLanguage]"></h3>
      <p [innerHTML]="appCopy.panelHeader['pageNotFoundMessage'+selectedLanguage]"></p>
    </div>
  </div>
</div>
